import shouldForwardProp from '@styled-system/should-forward-prop'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import styled from 'styled-components'
import { border, layout, space } from 'styled-system'

const VideoContainer = styled('div').withConfig({ shouldForwardProp })(
  {
    video: {
      borderRadius: 'inherit'
    }
  },
  space,
  layout,
  border
)

export const Video = forwardRef(
  (
    {
      src,
      alt,
      type = 'video/mp4',
      borderRadius = 24,
      autoplay = false,
      ...props
    },
    ref
  ) => {
    const videoRef = useRef()
    useImperativeHandle(ref, () => videoRef.current)

    return (
      <VideoContainer
        ref={videoRef}
        borderRadius={borderRadius}
        {...props}
        dangerouslySetInnerHTML={{
          __html: `
    <video
      loop
      muted
      ${autoplay ? 'autoplay' : ''}
      playsInline
      type="${type}"
      width="auto"
      height="100%"
      src="${src}"
      alt="${alt}">
      Your browser does not support the video tag.
    </video>
  `
        }}
      />
    )
  }
)
